export function generateFakeUUIDv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
}

export const getTrainEnd = (minutes = 10) => {
  const trainEnd = new Date();
  trainEnd.setMinutes(trainEnd.getMinutes() + minutes);
  trainEnd.setSeconds(trainEnd.getSeconds() + 10);
  return trainEnd;
};

export const getTrainDonations = (donationAmount = "5", donations = 10) => {
  return Array.from(Array(donations).keys()).map((i) => ({
    donorName: `Donor ${i + 1}`,
    campaignID: "1",
    causeID: "1",
    id: `donation-${i.toString()}`,
    completedAt: new Date().toISOString(),
    amount: {
      value: donationAmount,
    },
  }));
};

export const getTrain = (campaignID, donationAmount, minutes, donations = 10) => {
  const generatedDonations = getTrainDonations(donationAmount, donations);

  return {
    id: generateFakeUUIDv4(),
    campaignID,
    donationValue: donationAmount,
    trainActive: true,
    trainStart: new Date(),
    trainStatus: "ACTIVE",
    trainEnd: getTrainEnd(minutes),
    trainVisible: true,
    lastDonation: new Date(),
    donationCount: generatedDonations.length,
    donations: generatedDonations,
    ruleset: null,
  };
};
